import { Button } from '@cropler/ui-kit';

import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './stylesChartLegend.module.scss';

import { ChartLegendItemCircle } from './index.jsx';

const ChartLegendSoil = ({ t, title, data, units, onDownloadCsv }) => {
  return (
    <div className={styles.chartLegend}>
      <div className={styles.chartLegendItem}>
        <h2 className={styles.chartLegendTitle}>
          {title}
          {units && <span className={styles.chartLegendUnits}>, {units}</span>}
        </h2>

        {onDownloadCsv && (
          <Button
            type="secondary"
            className={styles.chartLegendButton}
            icon={<CroplerIcon name="download" />}
            onClick={onDownloadCsv}
          />
        )}
      </div>

      {data && data.length && (
        <div className={styles.chartLegendItem}>
          {t('charts.legendSoil')}:
          {data.map((item) => (
            <ChartLegendItemCircle key={item.value} value={`${item.value} cm`} color={item.color} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ChartLegendSoil;
